import TextInput from '@atoms/Inputs/TextInput';
import RemoveIcon from '@svg/remove.svg';
import useDebounce from '@utils/useDebounce';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import styles from './HourRange.module.scss';

export default function HourRange({
  minHours: initMinHours,
  maxHours: initMaxHours,
  onChange,
}) {
  const [minHours, setMinHours] = useState(initMinHours);
  const [maxHours, setMaxHours] = useState(initMaxHours);
  const [validationError, setValidationError] = useState(
    'Minimum uren zijn hoger dan de maximum uren.'
  );
  const handleChange = useDebounce(onChange);

  const handleValidation = useCallback(() => {
    if (maxHours && +minHours > +maxHours) {
      setValidationError('Minimum uren zijn hoger dan de maximum uren.');
    } else {
      setValidationError('');
    }
  }, [minHours, maxHours]);

  const handleHourChange = (e, setHourInput) => {
    const value = +e.target.value;
    const minInput = +e.target.min;
    const maxInput = +e.target.max;

    if (value < minInput) {
      e.target.value = minInput;
    } else if (value > maxInput) {
      e.target.value = maxInput;
    }

    setHourInput(e.target.value);
    handleChange(e);
  };

  const handleMinHourChange = e => {
    handleHourChange(e, setMinHours);
  };

  const handleMaxHourChange = e => {
    handleHourChange(e, setMaxHours);
  };

  useEffect(() => {
    handleValidation();
  }, [minHours, maxHours, handleValidation]);

  useEffect(() => {
    if (minHours !== initMinHours) {
      setMinHours(initMinHours);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initMinHours]);

  useEffect(() => {
    if (maxHours !== initMaxHours) {
      setMaxHours(initMaxHours);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initMaxHours]);

  return (
    <>
      <div className={classNames(styles.container, 'u-grid', 'u-grid--2@md')}>
        <TextInput
          modifier="rangeInput"
          rowModifier="rangeInput"
          label="Minimaal"
          name="minHours"
          id="min-hours-id"
          onChange={handleMinHourChange}
          type="number"
          value={minHours}
          min={0}
          max={36}
        />
        <RemoveIcon className={styles.rangeIcon} />
        <TextInput
          modifier="rangeInput"
          rowModifier="rangeInput"
          label="Maximaal"
          name="maxHours"
          id="max-hours-id"
          onChange={handleMaxHourChange}
          type="number"
          value={maxHours}
          min={0}
          max={40}
        />
      </div>
      {validationError && (
        <span className={styles.validationError}>{validationError}</span>
      )}
    </>
  );
}

HourRange.propTypes = {
  minHours: PropTypes.string,
  maxHours: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
